var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-info-card',{attrs:{"title":"Legal"}},[_vm._l((_vm.features),function(feature){return _c('a',{key:feature.text,staticClass:"mb-8 grey--text text-body-1 d-block text-none",attrs:{"text":feature.text,"href":feature.url},domProps:{"innerHTML":_vm._s(`&rsaquo; ${feature.text}`)}})}),_c('div',[_vm._v("COPYRIGHT © 2021")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }